
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 104 104","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M67.57 9.547c17.835 0 32.294 14.56 32.287 32.521-.007 18-14.72 32.496-32.596 32.496H25.206c-12.338 0-22.524-9.977-22.565-22.4-.041-12.45 9.97-22.556 22.323-22.556 3.377 0 6.58.756 9.45 2.108a2.17 2.17 0 002.965-1.204C42.003 18.256 53.775 9.547 67.57 9.547z","fill":"#F9F3F1"}}),_c('path',{attrs:{"d":"M12.819 59.084c-.042-12.45 9.97-22.555 22.323-22.555 3.377 0 6.58.756 9.45 2.108a2.17 2.17 0 002.965-1.204c4.624-12.256 16.396-20.966 30.19-20.966 4.486 0 8.756.922 12.638 2.586-5.841-5.874-13.907-9.506-22.814-9.506-13.795 0-25.567 8.709-30.19 20.965a2.17 2.17 0 01-2.966 1.204 22.106 22.106 0 00-9.45-2.108c-12.354 0-22.364 10.106-22.323 22.556.033 9.92 6.534 18.279 15.434 21.245a22.29 22.29 0 01-5.257-14.325zM84.69 68.263c-.352-4.328-3.968-7.732-8.38-7.732-4.646 0-8.412 3.772-8.412 8.425 0 .867.13 1.703.374 2.49h-2.846a4.695 4.695 0 00-4.692 4.699c0 2.595 2.1 4.699 4.692 4.699h18.67a6.3 6.3 0 006.295-6.305 6.301 6.301 0 00-5.7-6.276z","fill":"#F3EAE6"}}),_c('path',{attrs:{"d":"M41.099 75.127c-.536-6.579-6.035-11.752-12.744-11.752-7.064 0-12.79 5.733-12.79 12.805 0 1.318.199 2.59.568 3.786h-4.327c-3.94 0-7.134 3.198-7.134 7.142 0 3.944 3.194 7.142 7.134 7.142h28.388c5.286 0 9.572-4.29 9.572-9.583a9.58 9.58 0 00-8.667-9.54z","fill":"#F3EAE6"}})])
          )
        }
      }
    